import { useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import { useDispatch, useSelector } from 'react-redux'
import WelcomeStepFooter from '../wizard-v2/components/WelcomeStepFooter'
import { CSSTransition, SwitchTransition } from 'react-transition-group'
import WizardModal from './WizardModal'
import LastSearch from './LastSearch'
import { clearStepsProgress, fetchDynamicSteps, setDataV2, setStep } from '../wizard-v2/onboardingSlice'
import useHandleBgBehavior from './useHandleBgBehavior'
import { buildSearch, getInitialV2State, transformWizardDataToFilters } from '../wizard-v2/wizardService'
import API from '../../api'
import { setData } from '../user/userSlice'
import abTesting from '../../services/abTesting'

const WizardDesktop = () => {
  const dispatch = useDispatch();
  const { currentStep, formV2: form } = useSelector((state) => state.onboarding);
  const portal = document.getElementById('wizard-desktop-buttons')
  const [showModal, setShowModal] = useState(window.location.search.indexOf('wizardWidget=true') > -1 || false);
  const [userProfile, setUserProfile] = useState(null);
  const { entryFlowParams } = useSelector(state => state.user);
  const buttonsRef = useRef(null);
  const wizardRef = useRef(null);
  const nodeRef = showModal ? wizardRef : buttonsRef;
  const transitionClassNames = showModal ? 'modal-fade' : 'footer-slide';
  const transitionTimings = showModal ? 300 : 600;
  const { show } = useSelector((state) => state.onboarding);

  useHandleBgBehavior()

  const handleExited = () => {
    if (showModal) {
      dispatch(setStep(0))
    }
  }

  useEffect(() => {
    document.dispatchEvent(new CustomEvent('wizard loaded'));
  }, []);

  const toggleModal = (state) => {
    setShowModal(state);
    if (state) {
      window.handleShowModal();
    } else {
      window.handleShowHome();
      dispatch(clearStepsProgress())
      dispatch(setDataV2({
        ...getInitialV2State()
      }))
    }
  }

  useEffect(() => {
    const getUserProfile = async () => {
      const data = buildSearch(form, entryFlowParams);
      const params = transformWizardDataToFilters(data);
      const userProfile = await API.getUserProfile(params);
      setUserProfile(userProfile?.data?.searchProfileData);
      dispatch(setData({ key: 'searchProfile', value: userProfile?.data?.searchProfileData }));
    }

    if (currentStep === 'hostingLevelPref' && abTesting.userPrefEnabled) {
      getUserProfile();
    }
  }, [dispatch, currentStep, form])

    useEffect(() => {
      if (userProfile) {
        dispatch(fetchDynamicSteps({ profileId: userProfile.id }));
      }
    }, [dispatch, userProfile])

  useEffect(() => {
    if (window.location.search.indexOf('wizardWidget=true') > -1 || show) {
      window.scrollTo(0, 0, { behavior: 'smooth' });
      toggleModal(true);
    }
  }, []);

  useEffect(() => {
    if (window.location.search.indexOf('wizardWidget=true') > -1 && showModal) {
      window.parent.postMessage({ wizardLoaded: true }, '*');
    }
  }, [showModal]);

  const buttons = (
    <div className="text-center">
      <SwitchTransition mode="out-in">
        <CSSTransition
          key={showModal}
          nodeRef={nodeRef}
          addEndListener={(done) => {
            nodeRef.current.addEventListener("transitionend", done, false);
          }}
          classNames={transitionClassNames}
          timeout={transitionTimings}
          onExited={handleExited}
        >
          <div ref={nodeRef}>
            {showModal
              ? <WizardModal closeModal={() => toggleModal(false)} />
              : <WelcomeStepFooter startWizard={() => toggleModal(true)} />}
          </div>
        </CSSTransition>
      </SwitchTransition>
      <LastSearch showWizardModal={showModal} />
    </div>
  )

  return createPortal(buttons, portal)
}

export default WizardDesktop
